<ng-container *transloco="let t">
    <div class="flex flex-col px-4 sm:px-16">
        <!-- Arrow-->
        <div class="mt-62">
            <div class="flex flex-row">
                <hr class="bg-primary w-24">
                <!-- Pre Title-->
                <p class="mt-5 ml-5 text-primary font-semibold">{{t('contact-us-pre-title')}}</p>
            </div>
        </div>
        <!-- Title-->
        <div class="mt-2 ml-4 font-medium text-3xl">{{t('contact-us-title')}}</div>



        <div class="flex flex-col md:flex-row mt-8">
            <!--Left Pane-->
            <div class="basis-1/2 px-4 md:px-8 pb-8">
                <div class="flex flex-row justify-around gap-4">
                    <!--Img 1-->
                    <div class="min-w-0">
                        <img src="assets/images/lift_box.jpeg" class="w-full max-w-96">
                    </div>
                    <!--Img 2-->
                    <div class="min-w-0">
                        <img src="assets/images/lagerage_entry.jpeg" class="w-full max-w-96">
                    </div>
                </div>

            </div>
            <!--Right pane-->
            <div class="basis-1/2 px-4 md:px-8">

                <form [formGroup]="_form" class="h-full">
                    <!-- Honeypot gegen Spam-Bots: für Menschen unsichtbar und nicht fokussierbar -->
                    <input type="text" [formControlName]="'website'" name="website" tabindex="-1" autocomplete="off"
                        aria-hidden="true" style="position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden">
                    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 h-full">

                        <mat-form-field (click)="sent=false"
                            class="col-span-2 sm:col-span-2 md:col-span-1 lg:col-span-1">
                            <mat-label class="text-white">{{t('contact-us-form-name')}}</mat-label>
                            <input matInput [placeholder]="'Max Musterman'" [formControlName]="'name'">
                        </mat-form-field>

                        <mat-form-field
                            class="col-span-2 sm:col-span-2 md:col-span-1 lg:col-span-1">
                            <mat-label class="text-white">{{t('contact-us-form-email')}}</mat-label>
                            <input matInput [placeholder]="'max.musterman@email.com'" [formControlName]="'email'">
                        </mat-form-field>


                        <mat-form-field class="col-span-2">
                            <mat-label class="text-white">{{t('contact-us-form-service-title')}}</mat-label>
                            <mat-select [formControlName]="'service'">
                                <mat-option *ngFor="let service of allServices" [value]="service?.id">
                                    {{t(service.i18nKey)}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="col-span-2">
                            <mat-label class="text-white">{{t('contact-us-form-request')}}</mat-label>
                            <textarea matInput [placeholder]="''" [formControlName]="'request'" rows="3"></textarea>
                        </mat-form-field>
                        <button mat-flat-button class="bg-primary text-black w-full sm:w-auto sm:min-w-48"
                            (click)="send()"
                            [disabled]="!_form.valid">{{t('contact-us-send-button')}}
                        </button>
                        <div *ngIf="sent"
                            class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative h-full flex flex-row justify-center items-center">
                            <span class="block sm:inline">{{t('contact-us-success')}}</span>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>


</ng-container>
